export const PASSWORD_CHANGE_REQUEST = "PASSWORD_CHANGE_REQUEST";
export const PASSWORD_CHANGE_SUCCESS = "PASSWORD_CHANGE_SUCCESS";
export const PASSWORD_CHANGE_ERROR = "PASSWORD_CHANGE_ERROR";

export const passwordChangeRequest = (payload) => ({
  type: PASSWORD_CHANGE_REQUEST,
  ...payload,
});

export const passwordChangeSuccess = () => ({
  type: PASSWORD_CHANGE_SUCCESS,
});

export const passwordChangeError = (error) => ({
  type: PASSWORD_CHANGE_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/password-change/actions.js